module.exports = __webpack_public_path__ + "static/media/Risk_Disclosure_v1.1.7a7bebb7.pdf";